// extracted by mini-css-extract-plugin
module.exports = {"side":"side-2PvbR","outer":"outer-1fLHN","inner":"inner-2BQ3e","header-trigger":"header-trigger-29rOL","drag-bar":"drag-bar-3gbVM","drag-bar-icon":"drag-bar-icon-2ZH53"};